<div class="modal-header py-2 inset-box-shadow">
  <h4 class="m-0 align-self-end">{{selectedAbility? 'Edit Ability' : 'New Ability'}}</h4>
  <button type="button" class="close" aria-label="Close"
          (click)="activeModal.dismiss('cancel')" id="closeModalBtn">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body custom-scrollbar">
  <form [formGroup]="abilityForm">
    <div class="mb-3 mr-2 col-6">
      <label>Ability Name</label>
      <input formControlName="name" type="text" class="form-control" ngbAutofocus>
    </div>

    <div class="d-flex" style="width: 65%">
      <div class="mb-3 col-6">
        <label>Casting Time</label>
        <input formControlName="castingTime" type="text" class="form-control">
      </div>
      <div class="mb-3 col-6">
        <label>Range</label>
        <input formControlName="range" type="text" class="form-control">
      </div>
      <div class="mb-3 col-6">
        <label>Duration</label>
        <input formControlName="duration" type="text" class="form-control">
      </div>
    </div>

    <div class="form-group ml-3 mr-3">
      <label>Description</label>
      <textarea id="description" rows="3" type="text-area" class="form-control" formControlName="description">
        </textarea>
    </div>
  </form>
</div>

<div class="modal-footer d-flex justify-content-between py-2">
  <button *ngIf="selectedAbility" (click)="delete()"
          class="btn btn-sm btn-danger ml-4" id="deleteButton" type="button">Delete
  </button>
  <div *ngIf="!selectedAbility"></div>
  <div class="mr-4">
    <button (click)="activeModal.close('cancel')" class="btn btn-sm btn-outline-secondary mr-2"
            id="cancelButton" type="button">Cancel
    </button>
    <button (click)="activeModal.close(save())" class="btn btn-sm btn-success" id="saveButton"
            [disabled]="!areChanges">{{selectedAbility ? 'Save' : 'Add Ability'}}
    </button>
  </div>
</div>
